import React from 'react';
import ReactModal from 'react-modal';
import { LayoutBuyThirdPersonModal } from './LayoutBuyThirdPersonModal';

import './buyThirdPersonModal.scss';

const BuyThirdPersonModal = ({ isOpen, onSubmitBuyThirdPerson, closeBuyThirdPersonModal }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container overflow-auto"
      overlayClassName="modal-overlay modal-overlay--top"
    >
      <LayoutBuyThirdPersonModal
        onSubmitBuyThirdPerson={onSubmitBuyThirdPerson}
        closeBuyThirdPersonModal={closeBuyThirdPersonModal}
      />
    </ReactModal>
  );
};

export default BuyThirdPersonModal;
